import React from "react";
import VideocamIcon from "@material-ui/icons/Videocam";
import { RESOURCE_ITEMS } from "../homeV2.constants";
import Reveal from "./Reveal";

const Resources = () => {
  return (
    <section className="hv2-resources" id="resources">
      <div className="home-v2__container">
        <Reveal as="div" className="hv2-resources__top">
          <h2 className="home-v2__h2">
            Build the career you <span className="home-v2__highlight">want</span>
          </h2>
          <span className="hv2-btn-text">
            Explore Career Resources <span>→</span>
          </span>
        </Reveal>

        <Reveal delay={0.08} className="hv2-resources__feature">
          <div className="rf-content">
            <h4>
              <VideocamIcon fontSize="inherit" /> How to create a video resume employers actually watch
            </h4>
            <p>Pro tips from hiring managers on what makes a video profile stand out.</p>
          </div>
          <span className="hv2-btn-text">
            Read more <span>→</span>
          </span>
        </Reveal>

        <Reveal delay={0.16} className="hv2-resources__grid">
          {RESOURCE_ITEMS.map((item) => (
            <div className="hv2-resources__item" key={item}>
              {item}
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Resources;
